import '../css/card.css';
import { Link } from "react-router-dom";

const ServiceItem = ({ headerText, list, Imgsrc,link,anchorPosition }) => {


  return (
    
    <li className="cards_item">
      <div className="card">
      
        <div className="card_image">
          <img src={Imgsrc} alt="Pic" />
        </div>
        <div className="card_content">
          <h2 className="card_title">{headerText}</h2>
          <div className="card_text">

            {list.length === 1 ? (

              <article>{list[0]}</article>

            ) : (
              <ul>
                {list.map((el, index) => (
                  <li key={index}>
                    {el}
                  </li>
                ))}
              </ul>
            )}

    

          </div>
        </div>
        {
          link ?(
            <Link to={link} style={{textDecoration:'none'}} className='Detail' state={{tabVal:anchorPosition,anchor:"default"}}>
          <span>了解更多</span>

        <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <circle cx="11" cy="11" r="8" />
  <line x1="21" y1="21" x2="16.65" y2="16.65" />
  <line x1="11" y1="8" x2="11" y2="14" />
  <line x1="8" y1="11" x2="14" y2="11" />
</svg>
        </Link>
          ):(null)
        }
        
      </div>
    </li>
  );

}

export default ServiceItem;